import type { CalendarAppointmentProjection } from '@/features/appointments/calendarAppointmentProjection';
import type { DecodedBrowserAppointment } from '@/features/appointments/types';
import type { ExternalCalendarEvent } from '@/types/calendar';

const PLACEHOLDER_TITLE_PATTERN =
  /^appointment ([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/iu;

export const parsePlaceholderAppointmentId = (title: string): string | null => {
  const match = PLACEHOLDER_TITLE_PATTERN.exec(title);
  return match?.[1]?.toLowerCase() ?? null;
};

type NativeAppointmentPlaceholderProjection =
  CalendarAppointmentProjection | DecodedBrowserAppointment;

export const buildAppointmentsByUuid = (
  appointments: readonly NativeAppointmentPlaceholderProjection[] | undefined,
): ReadonlyMap<string, NativeAppointmentPlaceholderProjection> => {
  const byUuid = new Map<string, NativeAppointmentPlaceholderProjection>();
  appointments?.forEach((appointment) => {
    byUuid.set(appointment.id.toLowerCase(), appointment);
  });
  return byUuid;
};

export const isMatchedNativeAppointmentPlaceholder = (
  event: ExternalCalendarEvent,
  appointmentsByUuid: ReadonlyMap<
    string,
    NativeAppointmentPlaceholderProjection
  >,
): boolean => {
  const appointmentId = parsePlaceholderAppointmentId(event.title);
  return appointmentId !== null && appointmentsByUuid.has(appointmentId);
};
